module.exports = __webpack_public_path__ + "media/images/city/063-obelisk-of-buenos-aires-a2e1fd4b55f906745c12d914507bce70.svg";